export default __webpack_public_path__ + "static/media/pw.1028c57f.jpg";